export function registerAuthMax() {
    Alpine.data('authMaxEnterCode', () => ({
        token: '',
        pending: false,
        pollCount: 0,
        error: '',
        copied: false,
        init() {
            const raw = this.$el.dataset.token;
            this.token = raw || '';
            this.pending = !!this.token;
            if (this.token) this.poll();
        },
        copyCode() {
            if (!this.token) return;
            navigator.clipboard.writeText(this.token).then(() => {
                this.copied = true;
                setTimeout(() => { this.copied = false; }, 2000);
            }).catch(() => { this.error = 'Не удалось скопировать'; });
        },
        poll() {
            if (!this.pending || !this.token) return;
            this.pollCount++;
            if (this.pollCount > 120) { this.pending = false; this.error = 'Истекло время ожидания. Обновите страницу.'; return; }
            fetch('/api/auth/max-status?token=' + encodeURIComponent(this.token))
                .then(r => r.json())
                .then(data => {
                    if (data.ok) { this.pending = false; window.location.href = data.redirect || '/dashboard'; }
                    else if (data.error === 'expired') { this.pending = false; this.error = 'Код истёк. Обновите страницу и получите новый.'; }
                    else { setTimeout(() => this.poll(), 2500); }
                })
                .catch(() => { this.error = 'Ошибка проверки. Попробуйте ещё раз.'; setTimeout(() => this.poll(), 3000); });
        }
    }));
}
